'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiWavesOutline = function TiWavesOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.7 17.9c0.8-0.9 1.3-2.1 1.3-3.3 0-1.3-0.5-2.6-1.5-3.5-0.9-1-2.2-1.5-3.5-1.5s-2.6 0.5-3.5 1.5c-0.4 0.4-0.9 0.6-1.5 0.6s-1.1-0.2-1.5-0.6c-2.2-2.3-5.3-3.6-8.5-3.6s-6.3 1.3-8.5 3.6c-1 0.9-1.5 2.2-1.5 3.5 0 1.2 0.5 2.4 1.3 3.3-0.8 1-1.3 2.1-1.3 3.4s0.5 2.4 1.3 3.3c-0.8 0.9-1.3 2.1-1.3 3.3 0 1.4 0.5 2.6 1.5 3.6 0.9 0.9 2.2 1.4 3.5 1.4s2.6-0.5 3.5-1.4c0.4-0.4 0.9-0.6 1.5-0.6s1.1 0.2 1.5 0.6c2.2 2.2 5.3 3.5 8.5 3.5 3.2 0 6.3-1.3 8.5-3.5 1-1 1.5-2.2 1.5-3.6 0-1.2-0.5-2.4-1.3-3.3 0.8-0.9 1.3-2.1 1.3-3.3s-0.5-2.4-1.3-3.4z m-2.5 11.2c-1.7 1.7-4 2.6-6.2 2.6-2.2 0-4.5-0.9-6.2-2.6-1-1-2.4-1.6-3.8-1.6-1.4 0-2.8 0.6-3.8 1.6-0.3 0.3-0.8 0.5-1.2 0.5s-0.9-0.2-1.2-0.5c-0.6-0.6-0.6-1.7 0-2.3 1.7-1.7 4-2.6 6.2-2.6 2.2 0 4.5 0.9 6.2 2.6 1 1 2.4 1.5 3.8 1.5 1.4 0 2.8-0.5 3.8-1.5 0.3-0.4 0.8-0.5 1.2-0.5s0.9 0.1 1.2 0.5c0.6 0.6 0.6 1.7 0 2.3z m-22.4-15.7c1.7-1.7 4-2.5 6.2-2.5 2.2 0 4.5 0.8 6.2 2.5 1 1.1 2.4 1.6 3.8 1.6 1.4 0 2.8-0.5 3.8-1.6 0.3-0.3 0.8-0.5 1.2-0.5s0.9 0.2 1.2 0.5c0.6 0.7 0.6 1.7 0 2.4-1.7 1.7-4 2.5-6.2 2.5-2.2 0-4.5-0.8-6.2-2.5-1-1.1-2.4-1.6-3.8-1.6-1.4 0-2.8 0.5-3.8 1.6-0.3 0.3-0.8 0.5-1.2 0.5s-0.9-0.2-1.2-0.5c-0.6-0.7-0.6-1.7 0-2.4z m22.4 9c-1.7 1.7-4 2.6-6.2 2.6-2.2 0-4.5-0.9-6.2-2.6-1-1-2.4-1.5-3.8-1.5-1.4 0-2.8 0.5-3.8 1.5-0.3 0.4-0.8 0.5-1.2 0.5s-0.9-0.1-1.2-0.5c-0.6-0.6-0.6-1.7 0-2.3 1.7-1.7 4-2.6 6.2-2.6 2.2 0 4.5 0.9 6.2 2.6 1 1 2.4 1.6 3.8 1.6 1.4 0 2.8-0.6 3.8-1.6 0.3-0.3 0.8-0.5 1.2-0.5s0.9 0.2 1.2 0.5c0.6 0.6 0.6 1.7 0 2.3z' })
        )
    );
};

exports.default = TiWavesOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/waves-outline.js
// module id = 2255
// module chunks = 0